import { render } from "./room-list.vue?vue&type=template&id=6fcd38c4&scoped=true"
import script from "./room-list.vue?vue&type=script&lang=js"
export * from "./room-list.vue?vue&type=script&lang=js"

import "./room-list.vue?vue&type=style&index=0&id=6fcd38c4&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fcd38c4"]])

export default __exports__